import Select from '../../../../CMSComponent/Forms/Fields/select'
import { primary_color } from '../../../../Helper/uiHelper'

const TicketStatus = ({ status, isEditMode, setUpdatedData }) => {
  if (isEditMode)
    return (
      <Select
        data={statusDropdown}
        noCache
        value={status}
        inputLabel={status}
        isTable
        onChangeValue={(id, value) => {
          setUpdatedData((data) => {
            return {
              ...data,
              status: value,
            }
          })
        }}
      />
    )
  if (status?.toLowerCase() === 'new' || status?.toLowerCase() === 'responded') {
    return (
      <div className='badge badge-primary text-light' style={{ background: primary_color }}>
        {status}
      </div>
    )
  } else if (status?.toLowerCase() === 'response required') {
    return <div className='badge badge-warning text-light'>{status}</div>
  } else if (status?.toLowerCase() === 'investigating' || status?.toLowerCase() === 'in review') {
    return <div className='badge badge-danger text-light'>{status}</div>
  } else if (status?.toLowerCase() === 'closed') {
    return <div className='badge badge-success text-light'>{status}</div>
  }
  return (
    <div className='badge badge-primary text-light' style={{ background: primary_color }}>
      {status}
    </div>
  )
}

const statusDropdown = {
  component_type: 'fields',
  component_name: 'select',
  name: 'status',
  is_layout: null,
  row_index: null,
  block_index: null,
  col: 6,
  section_rowspan: null,
  field_setting: {
    import: true,
    export: true,
    is_copy_allowed: null,
    depend_fields: null,
    disable_if: [],
    textarea: false,
  },
  cms_value: 'Status',
  permission: null,
  field_id: 'name',
  cms_key: 'Status',
  cms_tooltip: null,
  component_call_data_connection: {
    component_type: 'data_connection',
    component_name: 'manual',
    default_options: ['New', 'Response required', 'Investigating'],
  },
  selected_value: null,
  disabled: false,
  hidden: false,
  search: false,
  hide_from_grid: false,
  background_color: false,
  component_call_validation: null,
  component_call_actions: null,
  component_call_fields: null,
  format: {
    size: 12,
    searchable: false,
    is_multi_select: false,
  },
  place_holder: null,
  cms_sub_heading: '',
}
export default TicketStatus
